import React, { useEffect } from "react";

import Table from "../components/table/Table";

import Modal from "../components/modal/Modal";
import { Box } from "@mui/system";
import CustomerEntry from "./Customer/CustomerEntry";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllSuppliers } from "../redux/features/suppliers.features";
import { Link } from "react-router-dom";
import SupplierEntry from "./Supplier/SupplierEntry";
import StatusCard from "../components/status-card/StatusCard";

const suppliersTableHead = [
  "firstName",
  "lastName",
  "homeAddress",
  "businessAddress",

  "mobile",
  "email",
  "country",
  "city",
  "status",
  "Action"
];

const renderHead = (item, index) => <th key={index}>{item}</th>;

const renderBody = (item, index) => (
  <tr key={index}>
    {/* <td>{item.id}</td> */}
    <td>{item.firstName}</td>
    <td>{item.lastName}</td>
    <td>{item.homeAddress}</td>
    <td>{item.businessAddress}</td>
    <td>{item.mobile}</td>
    <td>{item.email}</td>
    <td>{item.country}</td>
    <td>{item.city}</td>
    <td>{item.status}</td>
    <td className="text-right flex items-center">
      <div className="bg-red-500 rounded p-2 bx bx-edit mx-2"></div>
      <div className="bg-green-500 rounded p-2 bx bx-show mx-2"></div>
    </td>
  </tr>
);

const Suppliers = () => {
  const dispatch = useDispatch();

  const [showModal, updateShowModal] = React.useState(false);

  const toggleModal = () => updateShowModal((state) => !state);

  useEffect(() => {
    dispatch(fetchAllSuppliers());
  }, [dispatch]);

  let suppliersState = useSelector((state) => {
    return state.suppliersReducer;
  });

  let { suppliers,loading } = suppliersState;

  useEffect(() => {
    
   
  }, [loading])
  

  return (
    <div>
      
    <div className="row">
    <div className="col-3">
          <StatusCard
            icon={"bx bx-user"}
            count={suppliers.length}
            title={"suppliers"}
          ></StatusCard>
        </div>
     
    </div>

      
    <div style={{marginLeft:-10, marginBottom:25,cursor:'pointer', fontSize:'1.2rem'}} className="">

      <div onClick={toggleModal} className="col-3 sidebar__item">
        <div className={`sidebar__item-inner active`}>
          <i className="bx bx-plus"></i>
          <span>Create New Supplier</span>
        </div>
      </div>
    </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card__body">
              
               {
                loading ? (<p>loading...</p>):
                (
                  <Table
                limit="10"
                headData={suppliersTableHead}
                renderHead={(item, index) => renderHead(item, index)}
                bodyData={suppliers}
                renderBody={(item, index) => renderBody(item, index)}
              />
                )
              }
            </div>
          </div>
        </div>
      </div>

      <Modal
        modal_title={"Create new supplier"}
        canShow={showModal}
        updateModalState={toggleModal}
      >
        <SupplierEntry />
      </Modal>
    </div>
  );
};

export default Suppliers;
